import ArrowPrev from "@/components/@icons/ArrowPrev.vue";
import ArrowNext from "@/components/@icons/ArrowNext.vue";

export default {
  name: "CustomPagination",
  components: { ArrowNext, ArrowPrev },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: { type: Number, required: true },
    perPage: { type: Number, default: 10 },
    total: { type: Number, required: true },
    hideIfOnePage: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    windowSize: { type: Number, default: 10 },
  },
  emits: ["update:modelValue", "change"],
  computed: {
    page() {
      return this.modelValue;
    },
    pageCount() {
      const total = Number(this.total);
      const perPage = Number(this.perPage);
      if (!Number.isFinite(total) || !Number.isFinite(perPage) || perPage <= 0) return 1;
      return Math.max(1, Math.ceil(total / perPage));
    },
    isPrevDisabled() {
      return this.disabled || this.page <= 1;
    },
    isNextDisabled() {
      return this.disabled || this.page >= this.pageCount;
    },
    showEdgeArrows() {
      return this.pageCount > this.windowSize;
    },
    visiblePages() {
      const total = this.pageCount;
      const size = this.windowSize;

      if (total <= size) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      const windowIndex = Math.floor((this.page - 1) / size);
      const start = windowIndex * size + 1;
      const end = Math.min(start + size - 1, total);

      const res = [];
      for (let p = start; p <= end; p++) res.push(p);
      return res;
    },
  },
  methods: {
    normalize(p) {
      const next = Number(p);
      if (!Number.isFinite(next)) return 1;
      return Math.min(this.pageCount, Math.max(1, next));
    },
    goTo(p) {
      if (this.disabled) return;
      const next = this.normalize(p);
      if (next === this.page) return;

      this.$emit("update:modelValue", next);
      this.$emit("change", next);
    },
    goPrev() {
      this.goTo(this.page - 1);
    },
    goNext() {
      this.goTo(this.page + 1);
    },
    goFirst() {
      this.goTo(1);
    },
    goLast() {
      this.goTo(this.pageCount);
    },
  },
};
